import { gql } from "@apollo/client";

export const paginationDetailsFragment = gql`
  fragment PaginationDetails on PaginationDetails {
    page
    take
    pageCount
    hasNextPage
    hasPreviousPage
  }
`